import { Slide, type SlideProps } from "@mui/material";
import { forwardRef } from "react";

export const SlideUpTransition = forwardRef<unknown, SlideProps>((props, ref) => {
  return <Slide ref={ref} direction="up" {...props} />;
});

SlideUpTransition.displayName = "SlideUpTransition";
